import React, { useEffect } from "react";
import webDevelopmentImage from "../Media/service2_web_development.avif";
import frontendImage from "../Media/service2_frontend.jpg";
import backendImage from "../Media/service2_backend.jpg";
import integrationImage from "../Media/service2_integration.jpg";
import ecommerceImage from "../Media/service2_ecommerce.jpg";
import Banner from '../Components/Banner.tsx';
import { useNavigate } from "react-router-dom";
import ProgressiveImageCustom from "../Components/ProgressiveImageCustom.tsx";

export default function WebDevelopmentServices() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = document.querySelectorAll(".services-list li");
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const handleInquiry = (featureName) => {
    navigate("/inquiry", { state: { preselectedTopic: featureName } });
  };

  return (
    <div className="service">
      <div className="page-content">
        <Banner
          image={webDevelopmentImage}
          textTop="Webentwicklung"
          textBottom="Der Webauftritt für ihr Unternehmen oder Ihre Idee"
          textColor="#ffffff"
        />

<section className="textcontainer">
  <div className="spacer-div-30px"></div>
  <h1>Web&shy;entwicklung – Maßgeschneidert, Zukunfts&shy;sicher, Leistungs&shy;stark</h1>
  <p>
    Ihre Website ist das digitale Aushängeschild Ihres Unternehmens oder Ihrer Idee. Sie ist der zentrale Ort für Ihre Online-Kommunikation, Ihr Angebot und Ihre Kundeninteraktionen. Wir bieten Ihnen maßgeschneiderte Weblösungen, die nicht nur technologisch auf dem neuesten Stand sind, sondern auch Ihre Marke und Vision optimal widerspiegeln. Mit einer hohen Benutzerfreundlichkeit, erstklassiger Performance und einer flexiblen, skalierbaren Architektur stellen wir sicher, dass Ihr Webauftritt auch langfristig erfolgreich bleibt.
  </p>
  <hr />

  <ul className="services-list">
    <li>
      <div className="list-title">
        <strong>Frontend-Entwicklung – Nutzer­zentrierte Ober­flächen für eine optimale User Experience</strong>
      </div>
      <ProgressiveImageCustom src={frontendImage} />
      <div className="list-description">
        <p>
          Der Erfolg eines Webauftritts hängt entscheidend von der Nutzererfahrung ab. Unsere Frontend-Lösungen sind nicht nur optisch ansprechend, sondern bieten auch eine intuitive Bedienbarkeit auf allen Geräten. Mit modernen Technologien und einem klaren Fokus auf **Responsive Design** schaffen wir interaktive, ästhetische und benutzerfreundliche Web-Oberflächen, die Ihre Nutzer begeistern und Ihre Marke bestmöglich präsentieren.
        </p>
      </div>
    </li>

    <li>
      <div className="list-title">
        <strong>Backend-Entwicklung – Leistungs­stark, sicher und skalierbar</strong>
      </div>
      <ProgressiveImageCustom src={backendImage} />
      <div className="list-description">
        <p>
          Die Grundlage einer erfolgreichen Webanwendung ist ein stabiles und sicheres Backend. Wir entwickeln robuste, leistungsstarke Backend-Systeme, die eine hohe Skalierbarkeit bieten und auch bei steigenden Anforderungen und Nutzerzahlen stets zuverlässig bleiben. Ob bei der Verwaltung von Daten, der Nutzerinteraktion oder der Integration von externen Systemen – unser Backend sorgt dafür, dass Ihre Anwendung auch langfristig erfolgreich bleibt.
        </p>
      </div>
    </li>

    <li>
      <div className="list-title">
        <strong>System­integration – Nahtlose Vernetzung für maximale Effizienz</strong>
      </div>
      <ProgressiveImageCustom src={integrationImage} />
      <div className="list-description">
        <p>
          Um ein nahtloses Nutzererlebnis zu gewährleisten, müssen alle Systeme miteinander kommunizieren. Wir integrieren Ihre Website effizient mit externen Systemen wie CRM, ERP oder anderen Cloud-Diensten. Unsere maßgeschneiderten API-Lösungen ermöglichen es Ihnen, verschiedene Anwendungen zu verbinden und Ihre Webanwendung optimal mit anderen Softwarelösungen zu integrieren – für eine bessere Leistung und Automatisierung.
        </p>
      </div>
    </li>

    <li>
      <div className="list-title">
        <strong>E-Commerce & Webshops – Erfolg durch maßgeschneiderte Online-Shops</strong>
      </div>
      <ProgressiveImageCustom src={ecommerceImage} />
      <div className="list-description">
        <p>
          Der Aufbau eines erfolgreichen Online-Shops erfordert mehr als nur eine funktionierende Plattform. Wir bieten maßgeschneiderte E-Commerce-Lösungen, die auf Ihre speziellen Bedürfnisse abgestimmt sind. Mit einem klaren Fokus auf Conversion-Optimierung, Maximierung der Sicherheit und erstklassiger Performance entwickeln wir benutzerfreundliche und skalierbare Online-Shops, die Ihr Online-Geschäft effektiv voranbringen.
        </p>
      </div>
    </li>
  </ul>
</section>




        <button
          className="anfrage-btn not-on-grid"
          onClick={() => handleInquiry("Websites und Webapps")}
        >
          Anfragen
        </button>
      </div>
    </div>
  );
}
